import { useEffect, useState, useCallback } from "react";
import { readConsent, writeConsent, purgeThirdPartyCookies, DEFAULT_CONSENT } from "../lib/consent";

/**
 * React hook exposing the current consent state plus helpers.
 * Re-renders whenever consent changes (including from the banner).
 */
export function useConsent() {
  const [consent, setConsent] = useState(() => readConsent());
  const [decided, setDecided] = useState(() => readConsent() !== null);

  useEffect(() => {
    const onChange = (event) => {
      setConsent(event.detail);
      setDecided(true);
    };
    window.addEventListener("cc:consent", onChange);
    return () => window.removeEventListener("cc:consent", onChange);
  }, []);

  const save = useCallback((categories) => {
    const next = writeConsent(categories);
    setConsent(next);
    setDecided(true);
    if (!next.analytics) purgeThirdPartyCookies();
    return next;
  }, []);

  const acceptAll = useCallback(
    () => save({ necessary: true, analytics: true, external: true }),
    [save]
  );

  const rejectAll = useCallback(
    () => save({ necessary: true, analytics: false, external: false }),
    [save]
  );

  return {
    consent: consent || DEFAULT_CONSENT,
    decided,
    save,
    acceptAll,
    rejectAll,
  };
}
